import React, { useState, useRef } from "react";
import { Button, Box, Typography } from "@mui/material";
import FormHelperText from "@mui/joy/FormHelperText";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import VideoPreviewComponent from "./VideoPreviewComponent";
import { toast } from "react-toastify";

const supportedFileTypes = [
  "mp4",
  "avi",
  "mov",
  "wmv",
  "mkv",
  "flv",
  "webm",
  "mpeg",
  "mpg",
  "3gp",
  "mts",
  "m2ts",
  "hevc",
  "h265",
  "mpd",
];

const Step2 = ({ formik, edited }) => {
  const [video, setVideo] = useState(null);
  const [dragValue, setDragValue] = useState(false);
  const [videoPreview, setVideoPreview] = useState(() =>
    edited
      ? formik.values.videoFile
      : formik.values.videoFile
      ? URL.createObjectURL(formik.values.videoFile)
      : null
  );
  const videoRef = useRef(null);

  // const drag1 = useRef(null);
  // const drag2 = useRef(null);
  // const drag3 = useRef(null);
  // const drag4 = useRef(null);
  // const drag5 = useRef(null);

  const dragLeaveEle = useRef([]);

  const handleVideoChange = (e) => {
    e.preventDefault();
    setDragValue(false);
    let file = null;
    if (e.target.files) {
      file = e.target.files[0];
    } else if (e.dataTransfer.files) {
      file = e.dataTransfer.files[0];
    }

    if (file) {
      const fileType = file.type.split("/")[1];
      const fileExt = file.name.split(".").pop().toLowerCase();
      // "";
      // "";
      if (
        !supportedFileTypes.includes(fileType) &&
        !supportedFileTypes.includes(fileExt)
      ) {
        // "";
        formik.setFieldValue("videoFile", null);
        formik.setFieldError("videoFile", "File type not supported");
        toast.error("File type not supported");
        return;
      }
      setVideo(file);
      setVideoPreview(URL.createObjectURL(file));
      formik.setFieldValue("videoFile", file);
    } else {
    }
  };

  return (
    <>
      <Box className="upload-video-wrapper">
        <Box
          // className="upload-video"
          className={dragValue ? "drag-area upload-video" : "upload-video"}
          onDragOver={(e) => {
            e.preventDefault();
            setDragValue(true);
          }}
          onDragLeave={(e) => {
            e.preventDefault();
            if (!dragLeaveEle.current.includes(e.target)) {
              setDragValue(false);
              return;
            } else {
            }
          }}
          onDrop={handleVideoChange}
        >
          {videoPreview ? (
            <VideoPreviewComponent
              VideoPreview={videoPreview}
              setVideoPreview={setVideoPreview}
              formik={formik}
              videoRef={videoRef}
            />
          ) : (
            <Button
              sx={{
                display: "flex",
                alignItems: "center",
                flexGrow: 1,
                width: "100%",
                height: "100%",
              }}
              onClick={() => {
                if (videoRef.current) {
                  videoRef.current.click();
                } else {
                }
              }}
              ref={(el) => dragLeaveEle.current.push(el)}
            >
              <FileUploadIcon
                className="file-upload-icon"
                ref={(el) => dragLeaveEle.current.push(el)}
              />
              <Typography
                className="label"
                ref={(el) => dragLeaveEle.current.push(el)}
              >
                Upload Video
              </Typography>
            </Button>
          )}
          <input
            type="file"
            accept="video/*"
            className="form-control"
            name="videoFile"
            id="video"
            style={{ display: "none" }}
            ref={videoRef}
            onChange={handleVideoChange}
            // value={formik.values.videoFile}/
          />
        </Box>
      </Box>
      {/* <FormHelperText sx={{ color: "red" }}>
        {formik.touched.videoFile && formik.errors.videoFile
          ? formik.errors.videoFile
          : ""}
      </FormHelperText> */}
    </>
  );
};

export default Step2;
